import httpClient from "../httpClient";
import { API_COMMENT_FLAG_CASE } from "../config";

const commentFlagCase = {
    create: (data) => httpClient.post(API_COMMENT_FLAG_CASE, data),
};

export default commentFlagCase;
